import React from "react";
import BlockyBoldText from "components/custom-texts/blocky-bold-text.tsx";

interface LoadingOverlayProps {
  show: boolean;
  message?: string;
  fullScreen?: boolean;
  zIndex?: number;
}

const LoadingOverlay = ({ 
  show, 
  message = "Loading...", 
  fullScreen = false,
  zIndex
}: LoadingOverlayProps) => {
  if (!show) return null;

  const defaultZIndex = fullScreen ? 9999 : 10;
  const backgroundColor = fullScreen ? "rgba(0, 0, 0, 0.8)" : "rgba(0, 0, 0, 0.7)";

  return (
    <div
      style={{
        position: fullScreen ? "fixed" : "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: backgroundColor,
        zIndex: zIndex || defaultZIndex,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div className="spinner-border text-light mb-3" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
      <BlockyBoldText style={{ color: "white", fontSize: "1.2rem" }}>
        {message}
      </BlockyBoldText>
    </div>
  );
};

export default LoadingOverlay; 